import axios from "axios";
import { API_BASE_URL } from "../../../../constants";

// Coach Team > Performance: the game analytics of one squad and season
// (GET coach/team/performance/, BUILD_SPEC B14 B). A module of its own:
// three suites factory-mock coachServices with exactly three functions, so
// a new export there would be undefined in them.
//
// fetchCoachTeamPerformance(team, season, coachEmail) resolves to the
// server's envelope {available, reason?, status, season, team, peer,
// payload, dataStatus, retryAfter?}:
//  - HTTP 202 (the squad's numbers are still being built) reads as
//    {available: false, status: "building", reason: "building"}; the hook
//    asks again;
//  - HTTP 403 (a coach CACHE has not verified) reads as
//    {available: false, reason: "not_verified"};
//  - anything else that fails (no answer, a 5xx, an empty body) rejects,
//    and the hook turns it into feed_error.

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// The coach/team/style/ parameters: {teamId, league, teamName, season, coachEmail}.
export const teamPerformanceParams = (team, season, coachEmail) => ({
  ...(team ? { teamId: team.teamId, league: team.league, teamName: team.currentTeam } : {}),
  ...(season ? { season } : {}),
  ...(coachEmail ? { coachEmail } : {}),
});

export const BUILDING_ANSWER = { available: false, status: "building", reason: "building" };
export const NOT_VERIFIED_ANSWER = { available: false, status: "ready", reason: "not_verified" };

export const fetchCoachTeamPerformance = async (team, season, coachEmail) => {
  let response;
  try {
    response = await axios.get(`${API_BASE_URL}/coach/team/performance/`, {
      headers: authHeaders(),
      params: teamPerformanceParams(team, season, coachEmail),
    });
  } catch (error) {
    if (error?.response?.status === 403) return { ...NOT_VERIFIED_ANSWER };
    throw error;
  }
  const body = response?.data;
  if (!body || typeof body !== "object") throw new Error("No team performance answer");
  if (response.status === 202 || body.status === "building") return { ...body, ...BUILDING_ANSWER };
  return body;
};
